"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _SortTableHeader = require("./SortTableHeader");

var _SortTableHeader2 = _interopRequireDefault(_SortTableHeader);

var _index = require("../../styles/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

const StyledTable = _styledComponents2.default.table.withConfig({
  displayName: "Table__StyledTable",
  componentId: "yn7tog-0"
})(["", " border-collapse:separate;border-spacing:0px;font-family:", ";width:100%;tr:hover{background-color:", ";}th{background-color:", ";color:", ";font-size:13px;font-weight:500;line-height:16px;padding:", "px;text-align:left;border-top:1px solid ", ";border-bottom:1px solid ", ";&:first-child{border-left:1px solid ", ";border-top-left-radius:6px;}&:last-child{border-right:1px solid ", ";border-top-right-radius:6px;}}td{color:", ";padding:", "px;border-bottom:1px solid ", ";&:first-child{border-left:1px solid ", ";}&:last-child{border-right:1px solid ", ";}}tr:last-child td{border-bottom:1px solid ", ";&:first-child{border-bottom-left-radius:6px;}&:last-child{border-bottom-right-radius:6px;}}"], _index.defaultBody, _index.fontFamily1, _index.colors.borderLight, _index.colors.tableHeaderBackgroundColor, _index.colors.tableHeaderTextColor, (0, _index.calcPadding)(4), _index.colors.tableHeaderBorderColor, _index.colors.tableHeaderBorderColor, _index.colors.tableHeaderBorderColor, _index.colors.tableHeaderBorderColor, _index.colors.black, (0, _index.calcPadding)(4), _index.colors.dropdownHover, _index.colors.border, _index.colors.border, _index.colors.border);

const Table = (_ref) => {
  let { children } = _ref,
      props = _objectWithoutProperties(_ref, ["children"]);

  return _react2.default.createElement(
    StyledTable,
    props,
    children
  );
};

Table.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string
};

Table.SortTh = _SortTableHeader2.default;

exports.default = Table;